import { render, staticRenderFns } from "./RemoveFromCompanyModal.vue?vue&type=template&id=f5a60642&scoped=true"
import script from "./RemoveFromCompanyModal.vue?vue&type=script&lang=ts"
export * from "./RemoveFromCompanyModal.vue?vue&type=script&lang=ts"
import style0 from "./RemoveFromCompanyModal.vue?vue&type=style&index=0&id=f5a60642&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a60642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5a60642')) {
      api.createRecord('f5a60642', component.options)
    } else {
      api.reload('f5a60642', component.options)
    }
    module.hot.accept("./RemoveFromCompanyModal.vue?vue&type=template&id=f5a60642&scoped=true", function () {
      api.rerender('f5a60642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/RemoveFromCompanyModal.vue"
export default component.exports